import styled from 'styled-components'

export const StyledLobby = styled.div`
  .trailer {
    /* background-color: #000; */
    position: absolute;
    top: 33%;
    left: 40.8%;
    right: 38.6%;
    bottom: 44%;
    img {
      width: 100%;
      /* height: 100%; */
    }
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  #banner {
    cursor: pointer;
    transition: 1s;
    &:hover {
      transform: scale(1.1);
    }
  }
`
